

import pages from './pages'
import home from './home/home-routing'
import rule from './rule/rule-routing'


export default [{
    path: '/pages',
    name: 'pages',
    component: pages,
    children:[
        ...home,
        ...rule,
    ]},
    {
        path: '',
        redirect: { name: 'rule' }
    }
]
